let pageConfig = {};

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '移动端管理'
    },
    {
        type: 'title',
        name: '车辆型号管理'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'modelId',
    editRouter: 'carDetail',
};

// 路由
pageConfig.listRouter = 'carsManage';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '移动端管理',
    },
    {
        type: 'router',
        name: '车辆型号管理',
        router: 'carsManage'
    },
    {
        type: 'title',
        name: '车辆型号详情',
    },
];

pageConfig.formRules = {
    vehicleModel: [{
        required: true,
        trigger: 'blur',
        message: '车辆型号不能为空',
    }],
    vehicleBrand: [
        {
            required: true,
            trigger: 'blur',
            message: '车辆品牌不能为空',
        }
    ],
};


export default pageConfig;
